export enum EventTypes {
  TriggerCameraAccess = 'triggerCameraAccess',
}

export interface BaseEvent {
  type: EventTypes;
}
